import { HYDRATE } from "next-redux-wrapper";
import { createAction, createSlice } from "@reduxjs/toolkit";
import { postEditFormsReducers } from "./postFormSlice";
import { PostFormState } from "./postFormSlice.types";
import { AppState } from "./store";

const hydrate = createAction<AppState>(HYDRATE);

export interface EditFormState extends PostFormState {}

const initialState: EditFormState = {
    coordinates: [],
    selectedDriveUpdated: false,
    selectedDriveValid: false,
    mileageUpdated: false,
    mileageValid: false,
    autoFilled: false,
    characteristicsFilled: false,
    photoFilled: false,
    descriptionFilled: false,
    contactsFilled: false,
    placeFilled: false,
    priceFilled: false,
    isFilled: false,
    selectedPics: [],
    selectedSellerType: "individual",
    selectedYearUpdated: false,
    selectedYearValid: false,

    selectedBodyTypeUpdated: false,
    selectedBodyTypeValid: false
};

export const editFormSlice = createSlice({
    name: "editForm",
    initialState,
    reducers: postEditFormsReducers,

    extraReducers: (builder) => {
        builder.addCase(hydrate, (state, action) => {
            return {
                ...state,
                ...action.payload.postForm
            };
        });
    }
});

export const {
    updateStatus,
    setBrand,
    setModel,
    setGeneration,
    setSelectedEngine,
    setSelectedDrive,
    setBodyType,
    setYear,
    setSelectedColor,
    setSelectedDescription,
    setSelectedPrice,
    setSelectedCity,
    setSelectedCountry,
    setSelectedPhone,
    setSelectedName,
    setSelectedSellerType,
    setSelectedBodyType,
    setSelectedMileage,
    setSelectedStreet,
    setSelectedPics,
    setSelectedOwnersQnt,
    setSelectedTransmission,
    setSelectedWheel,
    loadDefaultValues,
    reset,
    setHorsePower,
    setVin,
    setCoordinates
} = editFormSlice.actions;

export const selectFilledStatus = (state: AppState) => state.editForm;

export const actions = editFormSlice.actions;

export default editFormSlice.reducer;